module.exports = __webpack_public_path__ + "static/media/matrix.f24f7509.svg";